import { ExternalNavMakeLinkPage } from "../components/NavBarSite/_v1/ExternalNavMakeLinkPage";

//links que não aparecem na navbar
export const LINKS_INICIO = '';
export const LINKS_WEB_APP = '/app';

export const LINKS_PARA_CLIENTES = '/opc_gerais/sobre';
export const LINKS_PARA_MERCADOS = '/opc_gerais/estabelecimentos';
export const LINKS_APOIO_E_PATROCINEO = '/opc_gerais/crescer';

export const LINKS_CENTRAL_DE_AJUDA = '/opc_gerais/central_ajuda';
export const LINKS_TERMOS = '/opc_gerais/termos';

export const LINKS_WHATSAPP = 'https://api.whatsapp.com/send?phone=45988191601';
export const LINKS_CATARSE = 'https://www.catarse.me/toome_busca_de_precos_de_supermercado';
export const LINKS_YOUTUBE = 'https://www.youtube.com/@Toomeoficial';
export const LINKS_LINKEDIN = 'https://www.linkedin.com/in/toome-oficial';
export const LINKS_INSTAGRAM = 'https://www.instagram.com/toome_oficial/?next=%2F';
export const LINKS_EMAIL_COMERCIAL_TOOME = 'mailto:comercial@tonomercado.com.br';
export const LINKS_EMAIL_CONTATO_TOOME = "mailto:contato@tonomercado.com.br";

//links que aparecem na navbar
export const LINKS_NAV_INICIO = () => { return ExternalNavMakeLinkPage(LINKS_INICIO) };
export const LINKS_NAV_PARA_CLIENTES = () => { return ExternalNavMakeLinkPage(LINKS_PARA_CLIENTES) };
export const LINKS_NAV_PARA_MERCADOS = () => { return ExternalNavMakeLinkPage(LINKS_PARA_MERCADOS) };
export const LINKS_NAV_APOIO_E_PATROCINEO = () => { return ExternalNavMakeLinkPage(LINKS_APOIO_E_PATROCINEO) };

